import { render } from "./PolicyCompliance.vue?vue&type=template&id=1f32e462&scoped=true"
import script from "./PolicyCompliance.vue?vue&type=script&lang=js"
export * from "./PolicyCompliance.vue?vue&type=script&lang=js"

import "./PolicyCompliance.vue?vue&type=style&index=0&id=1f32e462&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f32e462"]])

export default __exports__